module.exports = __webpack_public_path__ + "static/decanter_of_endless_water-364012c2eb7f05f4ae0f657e96a15b83.jpeg";